<template>
  <el-dialog
    :visible.sync="viewVisible"
    append-to-body
    :before-close="exit"
    width="1200px"
  >
    <template slot="title">
      <span>试用商品</span>
      <span class="title_tips"
        >注意：设置开奖时间时，需大于等于报名结束时间（当前设置{{
          applyTimeEnd
        }}）且小于等于活动结束时间24小时（当前设置{{ activityEndTime }}）</span
      >
    </template>
    <el-form :model="form" label-width="180px" class="new-input-box">
      <el-form-item label="奖品来源：">
        <div>
          <jd-button @click="handlePrize">选择奖品</jd-button>
          <div
            style="
              display: flex;
              align-items: center;
              gap: 8px;
              margin-top: 12px;
            "
          >
            <img width="80" :src="form.logo" />
            <div style="color: #7b61ff">{{ form.title }}</div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="试用方式：">
        <el-radio-group v-model="form.tryWay">
          <el-radio :label="0">0元试用</el-radio>
          <el-radio :label="1">积分试用</el-radio>
        </el-radio-group>
        <div v-show="form.tryWay == 1">
          <span>消耗</span>
          <el-input
            v-model="form.needPointAmount"
            @input="validateScoreInput"
            style="width: 100px; margin: 0 8px"
          ></el-input>
          <span>积分获得试用报名机会，至多输入99999</span>
        </div>
      </el-form-item>
      <el-form-item>
        <template #label>
          <span>开奖方式:</span>
          <el-tooltip
            effect="light"
            placement="top-start"
            popper-class="custom-popper"
          >
            <template #content>
              <div>
                1、手动审核：店铺需要前往活动报名记录手动标记用户中奖，标记时间需小于试用商品开奖时间，若勾选此项但未进行标记任何用户中奖，则开奖时间后中奖用户人数为0
              </div>
              <div>
                2、随机分配：开奖时间后从报名人数中抽取用户中奖，抽取人数≤试用商品奖品份数。若奖品份数＞报名人数，则报名的人中人人都可中奖
              </div>
              <div>
                3、比例分配：按照报名人数的数量，每X人报名即可中奖一份，可设置最低报名人数是中奖1份或不中奖。
              </div>
              <div>设置例子说明：</div>
              <div>
                设置每10人报名即可中奖1份，则活动报名为20人时，会从20人中随机抽取2人中奖，抽取人数≤试用商品奖品份数。注，若活动报名人数/每x人含小数位时，如选择低于XX人时不中奖，则中奖人数取 报名人数/每100人 的整数部分，如选择可中奖1份，则中奖人数取 报名人数/每100人 +1位。如设置每100人可中奖一份。假设报名人数为890，890/100= 8.9  ＜ 10 ，则奖品发放份数为8或9 
              </div>
            </template>
            <i class="el-icon-question" style="color: #ccc"></i>
          </el-tooltip>
        </template>
        <el-radio-group
          style="display: flex; flex-direction: column"
          v-model="form.rewardWay"
        >
          <el-radio style="line-height: 32px" :label="0">手动审核开奖</el-radio>
          <el-radio style="line-height: 32px" :label="1"
            >手动审核开奖，若开奖时间前，手动标记中奖人数为0，则开奖时间后不限制参与人数随机分配中奖</el-radio
          >
          <el-radio style="line-height: 32px" :label="3">
            <span>每</span>
            <el-input
              @input="validateDigitInput1"
              :disabled="form.rewardWay != 3"
              style="width: 80px; margin: 0 8px"
              placeholder="请输入"
              v-model="form.personNumOnePrize"
            ></el-input>
            <span>人报名可中奖1份奖品，最多不超过试用奖品份数，低于</span>
            <el-input
              @input="validateDigitInput2"
              :disabled="form.rewardWay != 3"
              style="width: 80px; margin: 0 8px"
              placeholder="请输入"
              v-model="form.minPersonNum"
            ></el-input>
            <span>人报名时</span>
            <el-select
              :disabled="form.rewardWay != 3"
              style="width: 100px; margin: 0 8px"
              v-model="form.rewardFlag"
              placeholder="请选择"
            >
              <el-option label="不中奖" :value="0"></el-option>
              <el-option label="中奖1份" :value="1"></el-option>
            </el-select>
          </el-radio>
          <el-radio style="line-height: 32px" :label="2"
            >开奖时间后不限制参与人数随机分配中奖</el-radio
          >
      
        </el-radio-group>
        <div v-if="form.rewardWay == 2" style="display: block; 
                    padding: 10px;
                    margin-top: 10px;
                    background-color: #fdf5e6;">
                  <div>
                  <div class="label">中奖条件（不勾选则不限制）</div>
                  <el-checkbox v-model="form.onlyConsumeUser">仅抽取报名参与且在店内消费大于 
                  <el-input :disabled="!form.onlyConsumeUser" v-model="form.trialConsumeAmount" :min="0"  style="width: 100px; margin: 0 10px;"></el-input> 元的用户（如参与用户中无消费则不中奖）</el-checkbox>
                  </div>
        </div>
      </el-form-item>
      <el-form-item label="收货信息填写截止时间：">
        <div class="my_select_time">
          <el-date-picker
            prefix-icon="no_icon"
            v-model="form.addressFillEndTime"
            type="datetime"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 180px; font-size: 12px"
            :picker-options="addressPickerOptions"
            :default-time="applyTimeStart.substring(11,applyTimeStart.length)"
          >
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item label="奖品份数：">
        <el-input
          @input="validatePrizeInput"
          style="width: 80px; margin-right: 8px"
          placeholder="请输入"
          v-model="form.totalAmount"
        ></el-input>
        <span>份，至多输入99999</span>
      </el-form-item>
      <el-form-item label="开奖时间：">
        <div class="my_select_time">
          <el-date-picker
            prefix-icon="no_icon"
            v-model="form.awardTime"
            type="datetime"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 180px; font-size: 12px"
            :picker-options="pickerOptions"
            :default-time="applyTimeEnd.substring(11, applyTimeEnd.length)"
          >
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item label="申请理由：">
        <el-checkbox v-model="form.reasonFillFlag"
        :true-label="1"
        :false-label="0"
          >用户报名需要输入申请理由</el-checkbox
        >
      </el-form-item>
    </el-form>
    <!-- 奖品弹窗 -->
    <select-product
      ref="selectProduct"
      v-if="showDialog"
      :echoDate="echoDate"
      :actId="valueRow"
      :JingdouCount="JingdouCount"
      :isShowCoupon="false"
      :isShowJingdou="false"
      :isShowManage="false"
      :isShowEK="false"
      :isShowIQY="false"
      :isShowPLUS="false"
      :isShowHongBao="false"
      :isShowGiftCard="false"
      :hideShopPoints="true"
      :showExclusive="false"
      :showNewToken="false"
      defaultSelect="third"
      @choose-shop="getTheData"
    ></select-product>

    <span slot="footer" class="dialog-footer">
      <jd-button @click="exit">取消</jd-button>
      <jd-button type="break" @click="submit">确定</jd-button>
    </span>
  </el-dialog>
</template>

<script>
import selectProduct from "../select_product";
export default {
  name: "trial_select",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    trialData: {
      type: Object,
      default: () => {
        return {
          backgroundOpacity: true,
          logo: "",
          title: "",
          tryWay: 0,
          rewardWay: 2,
          rewardFlag: 0,
          personNumOnePrize: "",
          minPersonNum: "",
          addressFillEndTime: "",
          totalAmount: null,
          awardTime: "",
          reasonFillFlag: false,
          prizeType: null,
          price: null,
          logo: null,
          title: "",
        };
      },
    },
    activityEndTime: {
      type: String,
      default: "",
    },
    applyTimeEnd: {
      type: String,
      default: "",
    },
    applyTimeStart: {
      type: String,
      default: "",
    },
    valueRow: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    selectProduct,
  },
  mounted() {
    this.form = JSON.parse(JSON.stringify(this.trialData));
    this.echoDate = this.trialData;
  },
  watch: {
    "form.personNumOnePrize": {
      handler(val) {
        this.form.minPersonNum = this.form.personNumOnePrize;
      },
    },
    "form.rewardWay"(newVal, oldVal) {
      if (newVal != 3) {
        this.form.personNumOnePrize = "";
        this.form.minPersonNum = "";
        this.rewardFlag = 0;
      }
    },
    "form.addressFillEndTime"(addressFillEndTime) {
      const selectTime = new Date(addressFillEndTime).getTime();
      const activityEndTime = new Date(this.activityEndTime);
      const applyTimeStart = new Date(this.applyTimeStart);
      const currentTime = activityEndTime.getTime();
      const currentApplyTime = applyTimeStart.getTime()
       // 活动结束时间的24小时
      //  let newTme = new Date(activityEndTime.getTime() - 24 * 60 * 60 * 1000);
      if(selectTime < currentApplyTime) {
        const hours = String(applyTimeStart.getHours()).padStart(2, "0");
        const minutes = String(applyTimeStart.getMinutes()).padStart(2, "0");
        const seconds = String(applyTimeStart.getSeconds()).padStart(2, "0");
        this.addressPickerOptions.selectableRange = `${hours}:${minutes}:${seconds} - 23:59:59`;
      } else if (selectTime >= currentTime) {
        const hours = String(activityEndTime.getHours()).padStart(2, "0");
        const minutes = String(activityEndTime.getMinutes()).padStart(2, "0");
        const seconds = String(activityEndTime.getSeconds()).padStart(2, "0");
        this.addressPickerOptions.selectableRange = `00:00:00 - ${hours}:${minutes}:${seconds}`;
      } else {
        this.addressPickerOptions.selectableRange = `00:00:00 - 23:59:59`;
      }
    },
    "form.awardTime"(awardTime) {
      const selectTime = new Date(awardTime).getTime();
      const activityEndTime = new Date(this.activityEndTime);
      const applyTimeEnd = new Date(this.applyTimeEnd);
      const currentTime = activityEndTime.getTime() - 24 * 60 * 60 * 1000;
      const currentApplyTime = applyTimeEnd.getTime()
       // 活动结束时间的24小时
       let newTme = new Date(activityEndTime.getTime() - 24 * 60 * 60 * 1000);
      if(selectTime < currentApplyTime) {
        const hours = String(applyTimeEnd.getHours()).padStart(2, "0");
        const minutes = String(applyTimeEnd.getMinutes()).padStart(2, "0");
        const seconds = String(applyTimeEnd.getSeconds()).padStart(2, "0");
        this.pickerOptions.selectableRange = `${hours}:${minutes}:${seconds} - 23:59:59`;
      } else if (selectTime >= currentTime) {
        const hours = String(newTme.getHours()).padStart(2, "0");
        const minutes = String(newTme.getMinutes()).padStart(2, "0");
        const seconds = String(newTme.getSeconds()).padStart(2, "0");
        this.pickerOptions.selectableRange = `00:00:00 - ${hours}:${minutes}:${seconds}`;
      } else {
        this.pickerOptions.selectableRange = `00:00:00 - 23:59:59`;
      }
    },
   'form.onlyConsumeUser'(newVal) {
    if (!newVal && this.form.trialConsumeAmount) {
      this.form.trialConsumeAmount = ''; // 设置默认值为 0
    }
  }
  },
  computed: {
    viewVisible: {
      get() {
        return this.visible;
      },
      set() {
        this.$emit("update:visible", false);
      },
    },
  },
  data() {
    return {
      form: {
        tryWay: 0,
        needPointAmount: "",
        rewardWay: 2,
        rewardWayPreview: "",
        personNumOnePrize: "",
        minPersonNum: "",
        rewardFlag: 0,
        addressFillEndTime: "",
        totalAmount: "",
        awardTime: "",
        reasonFillFlag: false,
        prizeType: null,
        price: null,
        logo: null,
        title: "",
        trialConsumeAmount: "",
        onlyConsumeUser: false,
      },
      echoDate: {},
      JingdouCount: {
        prizeCount: 0,
      },
      showDialog: false, //控制商品弹窗
      addressPickerOptions: {
        disabledDate: (time) => {
          return (
            time.getTime() < new Date(this.applyTimeStart).getTime() - 8.64e7 ||
            time.getTime() >
              new Date(this.activityEndTime).getTime()
          );
        },
        selectableRange: "00:00:00 - 23:59:59",
      },
      pickerOptions: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() < new Date(this.applyTimeEnd).getTime() - 8.64e7 ||
            time.getTime() >
              new Date(this.activityEndTime).getTime() - 24 * 60 * 60 * 1000
          );
        },
        selectableRange: "00:00:00 - 23:59:59",
      },
    };
  },
  methods: {
    clearTime(formProp) {
      this.form[formProp] = "";
    },
    validateScoreInput(value) {
      const cleanedValue = value.replace(/[^0-9.]/g, "");
      const parts = cleanedValue.split(".");
      let formattedValue =
        parts.length > 2
          ? parts[0] + "." + parts.slice(1).join("")
          : cleanedValue;

      if (Number(formattedValue) > 99999) {
        formattedValue = "99999";
      }

      this.form.needPointAmount = formattedValue;
    },
    validateDigitInput1(value) {
      this.form.personNumOnePrize = value.replace(/[^0-9]/g, "");
    },
    validateDigitInput2(value) {
      this.form.minPersonNum = value.replace(/[^0-9]/g, "");
    },
    validatePrizeInput(value) {
      const cleanedValue = value.replace(/[^0-9]/g, "");
      let formattedValue = cleanedValue;

      if (Number(formattedValue) > 99999) {
        formattedValue = "99999";
      }
      this.form.totalAmount = formattedValue;
    },
    exit() {
      this.$emit("clearIndex");
      this.$emit("update:visible", false);
    },
    submit() {
      if (this.validateAll()) {
        this.calcRewardWay();
        this.$emit("submit", this.form);
      }
    },
    colseDialog() {
      this.showDialog = false;
      this.$forceUpdate();
    },
    validateAll() {
      if (!this.form.title) {
        this.$message.warning("请选择奖品");
        return false;
      }
      if (this.form.tryWay == 1 && !this.form.needPointAmount) {
        this.$message.warning("请输入所需消耗积分");
        return false;
      }
      if (!this.form.addressFillEndTime) {
        this.$message.warning("请选择收货信息填写截止时间");
        return false;
      }
      if (!this.form.totalAmount) {
        this.$message.warning("请输入奖品份数");
        return false;
      }
      if (!this.form.awardTime) {
        this.$message.warning("请选择开奖时间");
        return false;
      }
      if (this.form.rewardWay == 3 && !this.form.personNumOnePrize) {
        this.$message.warning("请输入每人中奖份数");
        return false;
      }
      if (this.form.rewardWay == 3 && !this.form.minPersonNum) {
        this.$message.warning("请输入最少报名人数");
        return false;
      }
      if(new Date(this.activityEndTime).getTime() < new Date(this.form.awardTime).getTime()) {
        this.$message.warning("开奖时间不能大于活动结束时间");
        return false;
      }
      if(new Date(this.applyTimeEnd).getTime() > new Date(this.form.awardTime).getTime()) {
        this.$message.warning("开奖时间不能小于报名结束时间");
        return false;
      }
      if (new Date(this.applyTimeStart).getTime() > new Date(this.form.addressFillEndTime).getTime()) {
        this.$message.warning("收货信息填写时间不能小于报名开始时间");
        return false;
      }
      if (new Date(this.activityEndTime).getTime() < new Date(this.form.addressFillEndTime).getTime()) {
        this.$message.warning("收货信息填写时间不能大于活动结束时间");
        return false;
      }
      if (this.form.onlyConsumeUser && !this.form.trialConsumeAmount && this.form.rewardWay == 2) {
        this.$message.warning("请输入最小消费金额");
        return false;
      }
      return true;
    },
    handlePrize() {
      this.showDialog = true;
      this.JingdouCount.prizeCount = this.form.totalAmount;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
      });
    },
    // 获取奖品
    getTheData(data, prizeType) {
      this.form.giftType = data.giftType;
      this.form.price = Number(data.discount);
      this.form.assetsId = data.skuId || data.couponId;
      this.form.logo = data.logo;
      this.form.prizeType = prizeType;
      this.form.title = data.name;
      // 检查是否为实物管理奖品 (prizeType=3 且 isGoodManage=1)
      if (prizeType == 3 && data.isGoodManage) {
        this.form.isGoodManage = data.isGoodManage;
      } else {
        this.form.isGoodManage = 0;
      }

      if (data.singleAmount) {
        this.form.singleAmount = data.singleAmount;
      }
      if(data.isGoodManage) {
        this.form.isGoodManage = data.isGoodManage;
      } else {
        this.form.isGoodManage = 0;
      }
      this.echoDate = {...this.form,...data}
      this.showDialog = false;
    },
    calcRewardWay() {
      switch (this.form.rewardWay) {
        case 0:
          this.form.rewardWayPreview = "手动审核开奖";
          break;
        case 1:
          this.form.rewardWayPreview =
            "手动审核开奖，若开奖时间前，手动标记中奖人数为0，则开奖时间后不限制参与人数随机分配中奖";
          break;
        case 2:
          this.form.rewardWayPreview = "开奖时间后不限制参与人数随机分配中奖";
          break;
        case 3:
          this.form.rewardWayPreview = `每${
            this.form.personNumOnePrize
          }人报名可中奖1份奖品，最多不超过试用奖品份数，低于${
            this.form.minPersonNum
          }人报名时${this.form.rewardFlag == 0 ? "不中奖" : "中奖一份"}`;
          break;
        default:
          break;
      }
    },
  },
};
</script>
<style lang="scss">
.custom-popper {
  max-width: 1000px;
}
.time-cust {
  .el-input__inner {
    border-right: 1px solid #dcdfe6 !important;
    border-top-right-radius: 4px !important;
    border-bottom-right-radius: 4px !important;
  }

  .el-input__inner:focus {
    border-right: 1px solid #7b61ff !important;
  }
}
</style>

<style lang="scss" scoped>
.returnBtn1 {
  border-radius: 4px;
  width: auto;
  height: 32px;
  line-height: 32px;
  text-align: center;
  color: #7b61ff;
  background: rgba(123, 97, 255, 0.1);
  border: 1px solid #7b61ff;
  &:hover {
    color: #fff;
    background: #7b61ff;
  }
}
.title_tips {
  margin-left: 20px !important;
  font-size: 13px !important;
  color: #ff0000 !important;
}
</style>
